var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97958 3.35869C9.92375 3.19947 9.76375 3.09165 9.58333 3.09165H6.41125L5.39501 0.264336C5.33834 0.106662 5.17917 0 4.99959 0C4.82001 0 4.66126 0.106276 4.60417 0.264336L3.58793 3.09165H0.416682C0.236266 3.09165 0.076266 3.19947 0.0204328 3.35869C-0.0354004 3.51792 0.0258495 3.69221 0.171683 3.79075L2.71959 5.50971L1.68793 8.37993C1.63085 8.53876 1.69043 8.71344 1.83543 8.81314C1.98085 8.91285 2.17835 8.91401 2.32501 8.81701L4.99959 7.0451L7.67417 8.81701C7.74667 8.86493 7.83125 8.88889 7.91625 8.88889C8.00333 8.88889 8.09 8.86377 8.16375 8.81314C8.30875 8.71383 8.36833 8.53915 8.31125 8.37993L7.27959 5.50971L9.8275 3.79075C9.97416 3.69221 10.0354 3.51753 9.97958 3.35869Z",
    fill: "#7D7C7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2cbb6fcc256e1a6d143b6304d9b3d832.svg";
export { ForwardRef as ReactComponent };